import { defineMessages } from 'react-intl'

const scope = 'app.containers.OffshoreTablePage'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Offshore',
  },
  count: {
    id: `${scope}.count`,
    defaultMessage: 'Offshore: {displayed} of {total}',
  },
  filters: {
    id: `${scope}.filters`,
    defaultMessage: 'Filters',
  },
})
